import React, {useEffect} from 'react';
import './Modal.scss';
import { CloseIcon, WarningIcon } from '../svg/index';

interface DeactivateEventTypeErrorModalProps {
  isModalOpen: boolean;
  eventName: string;
  close: () => void;
}

const DeactivateEventTypeErrorModal: React.FC<DeactivateEventTypeErrorModalProps> = ({ isModalOpen, eventName, close }) => {
  useEffect(() => {
    
      const closeOnEscapeKeyDown = (e: any) => {
        if ((e.charCode || e.keyCode) === 27) {
          close();
        }
      }
      document.addEventListener('keydown', closeOnEscapeKeyDown);
  
    return () => document.removeEventListener('keydown', closeOnEscapeKeyDown);
    
  }, [isModalOpen]);

  if (!isModalOpen) {
    return null;
  }
  return (
    <div className='modal'>
    <div className='modal-content'>
        <div className='text-wrapper'>
            <div className="header-wrapper">
              <span className="deactivate-title-container">
                 <span className ="deactivate-title-svg">
                    <WarningIcon />
                  </span>
                  <h2 className="header header_new">Event Can't Be Deactivated</h2>
              </span>
                <button className="close-icon" onClick={close}>
                    <CloseIcon />
                </button>
            </div>
            <p className="text"> Please close all open events on the dashboard before deactivating this event type.</p>
        </div>
        
        <div className='button-wrapper'>
            <auro-button variant="primary" fluid onClick={close}>
                <span className="btnlabel-white">Ok</span>
            </auro-button>
        </div>
    </div>
</div>


  );
}

export default DeactivateEventTypeErrorModal;